<template>
  <module-template title>
    <template #title>
      <v-row dense class="px-1" align="center">
        {{ $t("global.business-process.old-run-deletion") }}
      </v-row>
    </template>

    <v-card class="mb-3" style="background-color: #fff4e7">
      <v-card-title>
        <v-icon class="mr-2">pic-warning</v-icon>
        {{ $t("global.business-process.confirm-delete-old-runs") }}
      </v-card-title>

      <v-card-actions>
        <v-btn depressed class="error" @click="confirmDeleteOldRuns">{{
          $t("global.action.yes-delete")
        }}</v-btn>
        <v-btn depressed @click="goToInstance">{{
          $t("global.action.cancel")
        }}</v-btn>
      </v-card-actions>
    </v-card>

    <div v-for="(drp, i) in deletedRunsPerTask" :key="i">
      <v-card class="mb-3" v-if="drp.deletedRuns.length !== 0">
        <v-card-title>
          <strong> {{ $t("global.business-process.task") }}</strong>
          : {{ drp.taskName }}
        </v-card-title>
        <v-card-subtitle>{{
          $t("global.business-process.deleted-for-task")
        }}</v-card-subtitle>

        <v-card-text>
          <ooliba-basic-table
            v-if="drp.deletedRuns.length > 0"
            :headers="headers"
            :items="drp.deletedRuns"
            :loading="busy"
            no-pagination
            @row-clicked="onRowClick"
          >
            <template #[`item.dateCreated`]="{ item }">
              {{ formatDate(item.dateCreated) }}
            </template>
          </ooliba-basic-table>
        </v-card-text></v-card
      >
    </div>
    <v-overlay absolute :value="deletingOldRuns">
      <v-chip color="blue" dark>{{ $t("global.msg.deleting") }}</v-chip>
    </v-overlay>
  </module-template>
</template>

<script>
import { get, remove } from "@/model/api";
import { formatDate } from "@/model/util";
import ModuleTemplate from "@/components/layout/ModuleTemplate";
import OolibaBasicTable from "@/components/OolibaBasicTable";

export default {
  name: "OldRunDeletion",

  components: { ModuleTemplate, OolibaBasicTable },

  data() {
    return {
      bpInstance: {},
      deletedRunsPerTask: {},
      runDeletionMaxDate: undefined,
      busy: true,
      headers: [
        { text: "Id", value: "id" },
        {
          text: this.$t("global.concepts.name"),
          value: "title",
          width: "506px",
        },
        { text: this.$t("global.concepts.created-on"), value: "dateCreated" },
        {
          text: this.$t("global.modules.module"),
          value: "module",
          width: "242px",
        },
        {
          text: this.$t("global.concepts.version"),
          value: "moduleVersion",
          width: "180px",
        },
        {
          text: this.$t("global.concepts.status"),
          value: "status",
          width: "210px",
        },
      ],
      deletingOldRuns: false,
    };
  },

  methods: {
    formatDate,

    async getBPInstance(id) {
      return await get("/businessProcessInstance/" + id).catch((error) =>
        this.onError(error)
      );
    },

    async confirmDeleteOldRuns() {
      this.deletingOldRuns = true;
      await remove(
        "/businessProcessInstance/delete-old-runs?id=" + this.bpInstance.id
      )
        .then(() => this.goToInstance())
        .catch((error) => this.onError(error));
      this.deletingOldRuns = false;
    },

    goToInstance() {
      this.$router.push({
        name: "BP instance",
        params: { bpId: this.$route.params.bpId },
      });
    },

    onRowClick(item) {
      const runId = item.id;
      this.$router.push({ name: "Run", params: { runId: runId } });
    },
  },

  async created() {
    const bpId = this.$route.params.bpId;
    this.bpInstance = await this.getBPInstance(bpId);

    this.runDeletionMaxDate = await get(
      "/environment-property/run-deletion-max-date"
    ).catch((error) => {
      this.$store.commit("showError", error);
    });

    this.deletedRunsPerTask = await get(
      "/businessProcessInstance/old-runs-per-task?id=" + this.bpInstance.id
    ).catch((error) => this.onError(error));
    this.busy = false;
  },
};
</script>
